<template>
	<div>
		<el-button :loading="enableLoading" size="small" @click="changeAttrInBtnGroup(1)" type="success" plain>审核通过</el-button>
		<el-button :loading="disableLoading" size="small" @click="changeAttrInBtnGroup(0)" type="warning" plain>继续审核</el-button>
		<!-- <el-button :loading="deleteLoading" size="small" @click="changeAttrInBtnGroup(-1)" type="danger" plain>删除员工</el-button> -->
	</div>
</template>

<script>
  import http from '../../assets/js/http'

  export default {
    props: ['selectedData', 'type', 'name', 'id'],
    data() {
      return {
        enableLoading: false,
        disableLoading: false,
        deleteLoading: false
      }
    },
    methods: {
      getUrl() {
        return 'admin/' + this.type
      },
      getSelectedIds() {
        let array = []
        _(this.selectedData).forEach((res) => {
          array.push(res.id)
        })
        return array
      },
      changeAttrInBtnGroup(cate) {
        this.$confirm('确认操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (!this.selectedData.length) {
            _g.toastMsg('warning', '请勾选数据')
            return
          }
          let word = ''
          if (cate == 1) {
            word = '恢复正常'
            this.enableLoading = true
          } else if (cate == 0) {
            this.disableLoading = true
            word = '开启审核'
          } else {
            this.deleteLoading = true
            word = '退出企业'
          }
          let url = this.getUrl() + '/user_enables'
          let data = {
            ids: this.getSelectedIds(),
            status: cate
          }
          this.apiPost(url, data).then((res) => {
            this.handelResponse(res, (data) => {
              _g.toastMsg('success', '操作成功')
              setTimeout(() => {
                if (cate == 1) {
                  this.enableLoading = false
                } else {
                  this.disableLoading = false
                }
                this.showgoback()
              }, 1500)
            }, () => {
              if (cate == 1) {
                this.enableLoading = false
              } else {
                this.disableLoading = false
              }
            })
          })
        }).catch(() => {
          // catch error
        })
      },
      deleteDatasInBtnGroup() {
        if (!this.selectedData.length) {
          _g.toastMsg('warning', '请勾选数据')
          return
        }
        this.deleteLoading = true
        let url = this.getUrl() + '/user_deletes'
        let data = {
          ids: this.getSelectedIds()
        }
        this.apiPost(url, data).then((res) => {
          this.handelResponse(res, (data) => {
            _g.toastMsg('success', res.data)
            setTimeout(() => {
              this.showgoback()
            }, 1500)
          }, () => {
          })
        })
      },
      showgoback(){
        this.deleteLoading = false
        this.enableLoading = false
        this.disableLoading = false
        this.$emit('closeMain', 0)
      }
    },
    computed: {
      enableShow() {
        return _g.getHasRule(this.type + '-enables')
      },
      deletesShow() {
        return _g.getHasRule(this.type + '-deletes')
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// btn-company-user.vue?95b4e630